import React from 'react';
import './App.css';
import { BrowserRouter as Router, Link, Switch, Route } from 'react-router-dom';
import Upload from './pages/Upload.js';
import Upload202308 from './pages/Upload202308.js';
import Upload202310 from './pages/Upload202310.js';
import Home from './pages/Home.js';
function App() {
    return (
        <div className="container">
            <Router>
                <nav className="nav">
                    <div className="nav-brand"></div>
                    <ul className="nav-items">
                    </ul>
                </nav>
                <Switch>
                    <Route component={Upload} path="/" exact />
                    <Route component={Upload202308} path="/sorteio" />
                    <Route component={Upload202310} path="/final" />
                    <Route component={Home} path="/home" />
                </Switch>
            </Router>
        </div>
    );
}

export default App;
